// TODO: update mockData to include: pamAccountType which is the new key to match the account filters with, and platformType for platform
export const mockData = {
  result: {
    userAccesses: [
      {
        roleKey: 13137,
        roleName: 'ROle_GCP_AccessapprovalRequestsApprove',
        roleType: 'Emergency Access Role',
        roleMaxTimeFrameHrs: 1,
        type: 'role',
      },
      {
        roleKey: 13136,
        roleName: 'abc123',
        roleDisplayName: 'ABC 123',
        roleType: 'Emergency Access Role',
        roleDescription: 'updating description',
        roleMaxTimeFrameHrs: 1400,
        type: 'role',
      },
      {
        roleKey: 13135,
        roleName: 'AWSRole_SHAIK',
        roleType: 'Emergency Access Role',
        roleDescription: 'AWSRole_SHAIK updated',
        roleMaxTimeFrameHrs: 2,
        type: 'role',
      },
      {
        roleKey: 13134,
        roleName: 'GCP_Role1',
        roleType: 'Emergency Access Role',
        roleDescription: 'GCP_Role1',
        roleMaxTimeFrameHrs: 3,
        type: 'role',
      },
      {
        roleKey: 13133,
        roleName: 'test_ff_role_1',
        roleDisplayName: 'test_ff_role_1',
        roleType: 'Emergency Access Role',
        roleDescription: 'test_ff_role_1_updated',
        roleMaxTimeFrameHrs: 8,
        endpointKey: 2077,
        endpointName: 'Doc_AD_PAM',
        endpointDisplayName: 'Doc_AD_PAM',
        assetType: 'Application',
        platformType: 'Active Directory',
        type: 'role',
      },
      {
        roleKey: 13127,
        roleName: 'AWS Admin',
        roleDisplayName: 'AWS Admin',
        roleType: 'Emergency Access Role',
        roleDescription: 'adding new  description',
        roleMaxTimeFrameHrs: 60,
        type: 'role',
      },
    ],
  },
  count: 6,
};

// applicationType
export const mockPlatformResponse = {
  AZURE: 'Azure',
  AD: 'Active Directory',
  SAP: 'SAP',
  GCP: 'GCP',
  OKTA: 'Okta',
  AWS: 'AWS',
  AZURE_AD: 'AzureAD',
  SALESFORCE: 'Salesforce',
  ON_PREMISE: 'On-Premise',
};

export const mockPlatformResponseWithLabel = {
  AZURE: 'Azure',
  ON_PREMISE: 'On-Premise',
  AD: 'Active Directory',
  SAP: 'SAP',
  GCP: 'GCP',
  SALESFORCE: 'Salesforce',
  VAULT: 'Vault',
  OKTA: 'Okta',
  AWS: 'AWS',
  AZURE_AD: 'AzureAD',
};

export const mockPlatformResponseWithLabel1 = [
  {
    label: 'Azure',
    value: 'AZURE',
    isChecked: false,
    prefixIcon: {
      isApplicationIcon: true,
      kind: 'AZURE',
      size: 'xSmall',
    },
  },
  {
    label: 'Active Directory',
    value: 'AD',
    isChecked: false,
    prefixIcon: {
      isApplicationIcon: true,
      kind: 'AD',
      size: 'xSmall',
    },
  },
  {
    label: 'SAP',
    value: 'SAP',
    isChecked: false,
    prefixIcon: {
      isApplicationIcon: true,
      kind: 'SAP',
      size: 'xSmall',
    },
  },
  {
    label: 'GCP',
    value: 'GCP',
    isChecked: false,
    prefixIcon: {
      isApplicationIcon: true,
      kind: 'GCP',
      size: 'xSmall',
    },
  },
  {
    label: 'Okta',
    value: 'OKTA',
    isChecked: false,
    prefixIcon: {
      isApplicationIcon: true,
      kind: 'OKTA',
      size: 'xSmall',
    },
  },
  {
    label: 'AWS',
    value: 'AWS',
    isChecked: false,
    prefixIcon: {
      isApplicationIcon: true,
      kind: 'AWS',
      size: 'xSmall',
    },
  },
  {
    label: 'AzureAD',
    value: 'AZURE_AD',
    isChecked: false,
    prefixIcon: {
      isApplicationIcon: true,
      kind: 'AZURE_AD',
      size: 'xSmall',
    },
  },
  {
    label: 'Salesforce',
    value: 'SALESFORCE',
    isChecked: false,
    prefixIcon: {
      isApplicationIcon: true,
      kind: 'SALESFORCE',
      size: 'xSmall',
    },
  },
  {
    label: 'On-Premise',
    value: 'ON_PREMISE',
    isChecked: false,
    prefixIcon: {
      isApplicationIcon: true,
      kind: 'placeholder',
      size: 'xSmall',
    },
  },
];

// resourceType
export const mockAssetResponse = {
  DATABASE: 'Database',
  SERVER: 'Server',
  APPLICATION: 'Application',
  VAULT: 'Vault',
};

// TODO: Replace this Account data with correct key value pairs from API, and replace the filter logic in the ListRow comp.
export const mockAccountResponse = {
  SHARED_ACCOUNT: 'Shared Account',
  SERVICE_ACCOUNT: 'Service Account',
  JIT_ACCOUNT: 'Temporary Admin (JIT) Account',
};

export const mockCredintialRequest = {
  accesstype: 'PRIVILEGEDACCESS',
  requestor: 'pamadmin',
  requestedfor: 'pamadmin',
  comments: null,
  sessions: [
    {
      businessjustification: null,
      startdate: null,
      enddate: null,
      accountId: 3545,
    },
  ],
  pamtype: 'credentials',
};

export const mockCredintialRequestWillAllData = {
  accesstype: 'PRIVILEGEDACCESS',
  requestor: 'pamadmin',
  requestedfor: 'pamadmin',
  comments: null,
  sessions: [
    {
      businessjustification: true,
      accountId: 3545,
      justintimedetails: { endpointname: 'jitEndpointName' },
      remoteApp: {
        name: 'remoteAppName',
        displayName: 'remoteAppDisplayName',
        icon: 'remoteAppIcon',
        nativeLaunch: '',
      },
      startdate: new Date('2024-12-01'),
      enddate: new Date('2024-12-10'),
    },
  ],
  pamtype: 'credentials',
};

// Scheduler Component Mock Data
const newDate = new Date();

export const getMockDate = (date, days, hours) => {
  date.setDate(date.getDate() + days);

  date.setHours(date.getHours() + hours);

  return date.toISOString();
};

export const mockSessions = [
  {
    firstname: 'Huy',
    lastname: 'Pham',
    username: 'huy.pham',
    sessionStartDate: getMockDate(new Date('2024-12-24'), 0, 0),
    sessionEndDate: getMockDate(new Date('2024-12-27'), 0, 2),
    requestId: 4380307,
  },
  {
    firstname: 'Huy',
    lastname: 'Pham',
    username: 'huy.pham',
    sessionStartDate: getMockDate(newDate, 2, 0),
    sessionEndDate: getMockDate(newDate, 0, 2),
    requestId: 4380307,
  },
  {
    firstname: 'Nathan',
    lastname: 'Kim',
    username: 'nathan.kim',
    sessionStartDate: getMockDate(newDate, 0, 3),
    sessionEndDate: getMockDate(newDate, 0, 5),
    requestId: 4380308,
  },
  {
    firstname: 'Jacob',
    lastname: 'Eades',
    username: 'jacob.eades',
    sessionStartDate: getMockDate(newDate, 1, 3),
    sessionEndDate: getMockDate(newDate, 0, 5),
    requestId: 4380309,
  },
  {
    firstname: 'Yash',
    lastname: 'Agarwal',
    username: 'yash.agarwal',
    sessionStartDate: getMockDate(newDate, 2, 2),
    sessionEndDate: getMockDate(newDate, 0, 4),
    requestId: 4380310,
  },
];

export const mockRole = {
  endpointKey: 2032,
  endpointName: '51501a6b-1b96-4962-8995-68b0d66e31f9',
  endpointDisplayName: 'cpam-internal-mssql',
  assetType: 'Role',
  platformType: 'Azure',
  pamPlatformType: 'DB',
  summary: {
    syscritical: 'Medium',
    privileged: 'High',
    updatedate: '2017-09-13T21:17:11.000+00:00',
    rolename: 'Content Administrator:661222050851',
    confidentiality: 'Critical',
    rolekey: '7',
    soxcritical: 'Low',
    description:
      'Privileged access designed for content owners who need full access to CloudFront, S3, Glacier,\nKinesis Firehose, App Streams and Cloud Search.',
    roletype: 'Emergency Access',
    risk: 'Very Low',
    status: 1,
    updateuser: 1,
  },
  customProperties: {
    CustomProperty1: 'tnew-SaviyntContentAdministrator-6OO8DGA62RPK',
    CustomProperty2: 'AWSRole',
    CustomProperty3: 'AWS',
    CustomProperty4: '661222050851',
    CustomProperty5: 'tnew-SaviyntContentAdministrator-6OO8DGA62RPK',
    CustomProperty6: 'tnew-SaviyntContentAdministrator-6OO8DGA62RPJ',
    CustomProperty7: 'AWSRole 2',
    CustomProperty8: 'AWS Platform',
    CustomProperty9: '661222050852',
  },
  type: 'role',
  entitlements: [
    {
      name: 'Entitlement 1',
      description:
        'lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      type: 'Test Type',
      securitySystem: 'Test System',
      value: 'arn:aws:iam::aws:policy/AmazonS3FullAccess',
    },
    {
      name: 'Entitlement 2',
      description:
        'lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      type: 'Test Type',
      securitySystem: 'Test System',
      value: 'arn:aws:iam::aws:policy/AmazonS3FullAccess',
    },
    {
      name: 'Entitlement 3',
      description:
        'lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      type: 'Test Type',
      securitySystem: 'Test System',
      value: 'arn:aws:iam::aws:policy/AmazonS3FullAccess',
    },
    {
      name: 'Entitlement 4',
      description:
        'lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      type: 'Test Type',
      securitySystem: 'Test System',
      value: 'arn:aws:iam::aws:policy/AmazonS3FullAccess',
    },
    {
      name: 'Entitlement 5',
      description:
        'lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      type: 'Test Type',
      securitySystem: 'Test System',
      value: 'arn:aws:iam::aws:policy/AmazonS3FullAccess',
    },
    {
      name: 'Entitlement 6',
      description: 'lorem ipsum dolor sit amet, consectetur.',
      type: 'Test Type',
      securitySystem: 'Test System',
      value: 'arn:aws:iam::aws:policy/AmazonS3FullAccess',
    },
    {
      name: 'Entitlement 7',
      description: 'lorem ipsum dolor sit amet, consectetur.',
      type: 'Test Type',
      securitySystem: 'Test System',
      value: 'arn:aws:iam::aws:policy/AmazonS3FullAccess',
    },
    {
      name: 'Entitlement 8',
      description: 'lorem ipsum dolor sit amet, consectetur.',
      type: 'Test Type',
      securitySystem: 'Test System',
      value: 'arn:aws:iam::aws:policy/AmazonS3FullAccess',
    },
    {
      name: 'Entitlement 9',
      description: 'lorem ipsum dolor sit amet, consectetur.',
      type: 'Test Type',
      securitySystem: 'Test System',
      value: 'arn:aws:iam::aws:policy/AmazonS3FullAccess',
    },
  ],
};

export const mockRoleProps = {
  data: {
    roleKey: 1556,
    roleName: 'AWS Super Administrator:607998667071',
    roleDisplayName: 'AWS Super Administrator',
    roleType: 'Emergency Access Role',
    roleDescription:
      'Privileged access designed for super administrators with full access to AWS account.',
    type: 'role',
  },
  roleDetails: { request: {} },
  entitlements: [
    {
      evKey: 18011678,
      evEntitlementId: 'AROAY3D4LNE7X573NTWLK',
      evEntitlementValue:
        'sav-training-consolepam-SaviyntSuperAdministrator-1LVF8PJ3EYUL0',
      evStatus: 1,
      etName: 'AWSRole',
      etDisplayName: 'AWSRole',
      epKey: 2659,
      endpointName: 'AWS_0912_Without_REGION_FILTER',
      epDisplayName: 'AWS_0912_Without_REGION_FILTER',
      ssKey: 2641,
      ssSystemName: 'AWS_0912_Without_REGION_FILTER',
      ssDisplayName: 'AWS_0912_Without_REGION_FILTER',
      platformType: 'AWS',
    },
  ],
  scheduledSessions: [],
  dataTestId: 'SpvRoles',
  className: null,
};

export const SchedulerDetails = {
  firstname: 'Huy',
  lastname: 'Pham',
  username: 'huy.pham',
  startDate: getMockDate(newDate, 0, 0),
  endDate: getMockDate(newDate, 0, 2),
  requestId: 4380307,
};

export const SchedulerDetailsEmpty = {
  startDate: getMockDate(newDate, 0, 0),
  endDate: getMockDate(newDate, 0, 2),
  requestId: 4380307,
};

export const sessionLauncherProps = {
  osType: 'osType',
  accessKey: 'accessKey',
  requestId: 'requestId',
  userKey: 1234567,
};
